null


// WEBPACK FOOTER //
// /Volumes/workplace/PITLambda/RekognitionClient.ts